//mui imports====
import { useContext, useMemo } from 'react';
import { Box } from '@mui/system';
import useStyles from './styles';
import Typography from '@mui/material/Typography';
import { UserContext } from '../../Contexts/UserContext';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
//===============

const { SYSTEMS, UI_ACCESS, TYPES } = ACCESS_CONTROL_CONSTANTS;

const Option = ({
	icon = null,
	sidebarCollapsed = false,
	sidebarOptionHovered = false,
	selected,
	label,
	settingName,
	changeSetting,
	system = SYSTEMS.FRAMERATE
}) => {
	const classes = useStyles();
	const { getAccessControlSet } = useContext(UserContext);

	/**
	 * This set contains the access level of this particular option.
	 * @type {Set<string>}
	 */
	const optionControlledAccess = useMemo(() => {
		return getAccessControlSet(system, TYPES.SETTING_NAMES, settingName);
	}, [getAccessControlSet, settingName]);

	const hasSidebarCollapsed = sidebarCollapsed && !sidebarOptionHovered;

	let settingContainerClasses = hasSidebarCollapsed
		? `${classes.settingNameContainer} ${classes.settingNameContainerCollapsed}`
		: classes.settingNameContainer;
	let settingIconContainerClasses = hasSidebarCollapsed
		? `${classes.settingIconContainer} ${classes.settingIconContainerCollapsed}`
		: classes.settingIconContainer;

	if (selected) {
		settingContainerClasses = settingContainerClasses + ` ${classes.settingSelected}`;
	}

	return (
		<>
			{!optionControlledAccess.has(UI_ACCESS.HIDE) && (
				<Box
					onClick={() => {
						changeSetting(settingName);
					}}
					className={settingContainerClasses}
				>
					<Box className={settingIconContainerClasses}>
						{hasSidebarCollapsed ? (
							<>{icon ? icon : <FiberManualRecordIcon fontSize="small" />}</>
						) : (
							<>{icon}</>
						)}
					</Box>
					{!hasSidebarCollapsed && (
						<Typography variant="h6" className={classes.settingName} data-value="overview">
							{label}
						</Typography>
					)}
				</Box>
			)}
		</>
	);
};

export default Option;
